import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { ProviderRoutingInfo } from "@/types";

// #243: LLM-Provider-Routing. Mit agentId → per-Agent (GET /agents/:id/provider-routing, owner+admin);
// ohne → Plattform-Default (GET /provider-routing/platform, admin-only). Secret-frei.
export function useProviderRouting(agentId?: string): UseQueryResult<ProviderRoutingInfo> {
  const { session, logout } = useAuth();
  const path = agentId ? `/agents/${agentId}/provider-routing` : "/provider-routing/platform";
  const key = agentId
    ? queryKeys.subResource("agents", agentId, "provider-routing")
    : queryKeys.list("provider-routing");
  return useQuery({
    queryKey: key,
    queryFn: () => {
      const client = createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout });
      return client.get<ProviderRoutingInfo>(path);
    },
    enabled: !!session,
  });
}
